/**
 init-message-hub
 Created by RuSsCiTy on 07.05.2018
 **/
import Radio from "backbone.radio";
import { SERVER_CONST } from "../const/constants";
import { isInIframe } from "../utils/developer-utils";
import { isIE11 } from "../utils/browser";

/** All messages about the app module */
export const mainChannel = Radio.channel("main");
/** All messages about views */
export const viewChannel = Radio.channel("view");
/** All messages about showing notifications to the user */
export const notifyChannel = Radio.channel("notify");

export default class MessageHub {
  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src-cookie-manager/init/message-hub.js